import React from 'react';

/**
 * Enhanced Error Boundary specifically for notification-related components
 * Provides graceful degradation when notification system fails
 */
class NotificationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      errorType: null,
      errorMessage: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { 
      hasError: true, 
      errorType: error.name || 'NotificationError',
      errorMessage: error.message || 'Unknown notification error'
    };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error for debugging
    console.error('🚨 [NOTIFICATION ERROR BOUNDARY] Notification system error:', {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      errorBoundary: 'NotificationErrorBoundary'
    });

    // Report to error tracking service if available
    if (window.reportError) {
      window.reportError(error, {
        context: 'NotificationSystem',
        errorInfo
      });
    }
  }

  render() {
    if (this.state.hasError) {
      // Don't render anything on error - fail silently for notifications
      // This prevents notification errors from breaking the entire UI
      console.warn('🔕 [NOTIFICATION ERROR BOUNDARY] Hiding notification due to error:', {
        errorType: this.state.errorType,
        errorMessage: this.state.errorMessage
      });
      
      return null;
    }

    return this.props.children;
  }
}

export default NotificationErrorBoundary;